import AppIcon from "@/components/AppIcon";
import TinyOmnyIcon from "@/components/icons/TinyOmnyIcon.vue";
import TranslateIcon from "@/components/icons/TranslateIcon.vue";
export default {
  name: "AiAssistanceCard",
  components: {
    AppIcon,
    TinyOmnyIcon,
    TranslateIcon
  },
  props: {
    icon: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    selected: {
      type: Boolean,
      default: false
    }
  }
};